/**
 * Locale → country code, for the flag shown beside each language (F32).
 *
 * The two language pickers (app-shell header and Settings) each carried their
 * own hard-coded map of flag EMOJI keyed by locale. Windows has no glyphs for
 * regional-indicator pairs, so half of desktop users saw `GB`, `PT`, `BR` — or
 * an empty box — instead of a flag, in the one control whose whole job is to be
 * recognisable before you can read the page. The value here is an
 * ISO-3166-1 alpha-2 code that `<CountryFlag>` resolves to a vendored SVG.
 *
 * One map, two consumers: duplicating it is how the two pickers would drift.
 *
 * A locale is a language, not a country, so the pairing is a display
 * convention: `en` shows the United Kingdom because this platform's English is
 * European, and the remaining four locales are already region-qualified.
 */

import type { SupportedLocale } from '@tonnie/locale';

export const LOCALE_FLAG_COUNTRIES: Record<SupportedLocale, string> = {
  en: 'GB',
  'pt-PT': 'PT',
  'pt-BR': 'BR',
  'es-ES': 'ES',
  'it-IT': 'IT',
};
